import React from 'react';

type SkeletonAnimation = 'pulse' | 'wave' | 'none';

interface SkeletonInterventionCardProps {
  cardCount?: number;
  animation?: SkeletonAnimation;
}

export const SkeletonInterventionCard: React.FC<SkeletonInterventionCardProps> = ({
  cardCount = 4,
  animation = 'wave',
}) => {
  const cardIndexes = Array.from({ length: cardCount });

  return (
    <>
      {cardIndexes.map((_, index) => (
        <div key={`dashboard-card-${index}`} className="card-skeleton">
            <div className="top-row">
                <div className="left-header">
                    <div className="circle"></div>
                    <div className="title skeleton"></div>
                </div>
                <div className="pdf-btn skeleton"></div>
            </div>
            <div className="description skeleton"></div>
            <div className="tag-group">
                <div className="tag large skeleton"></div>
                <div className="tag skeleton"></div>
            </div>

            <div className="footer skeleton"></div>
        </div>
      ))}
    </>
  );
};

export default SkeletonInterventionCard;